module.exports = __webpack_public_path__ + "img/footerLogo.07e6ca2a.png";